// rte-links.js — upgrades the links inside merchant-typed rich text.
//
// USAGE:  put data-rte-links on any container; every <a href> inside it is upgraded once.
//
// WHY THIS IS JS AND NOT MARKUP: the links live in `richtext` theme SETTINGS (the accordion row
// bodies), and the theme editor's rich-text toolbar offers bold / italic / list / link and nothing
// else — there is no "open in new tab" control and no way to type a data- attribute. Anything extra
// hand-written into the JSON survives only until the merchant next edits that field in the editor,
// which silently rewrites the value. So the enhancement has to happen AFTER render, over the DOM.
//
// Two upgrades:
//   1. Real destinations (the Redo returns portal, forward2me) open in a new tab. The modal sits on
//      top of a PDP — following a link in place would throw away the product the visitor was reading.
//   2. mailto: links become click-to-copy, matching the size guide. A bare mailto does nothing at all
//      on a machine with no mail client registered, which is how most people meet it. The href STAYS
//      on the element on purpose: middle-click / "Copy link address" keep working, the underline
//      comes from the UA's a[href] rule, and with JS broken it degrades to the old mailto behaviour.
//      The copy itself is assets/copy-text.js (delegated on document) — we only mark the element.
//
// Idempotent; arms current AND future links via a MutationObserver, so theme-editor re-renders and
// ss-modal's adopt/return moves stay armed. Same shape as assets/wipe-line.js.
(function () {
  // Anything that is not a destination: in-page anchors and the '#' placeholder, plus tel: (dialling
  // is the correct action there, and a new tab for it would be nonsense).
  function isSkipped(href) {
    return !href || href.charAt(0) === '#' || href.indexOf('tel:') === 0;
  }

  function arm(a) {
    if (a.__rteLinked) return;
    a.__rteLinked = true;

    var href = a.getAttribute('href');
    if (isSkipped(href)) return;

    if (href.indexOf('mailto:') === 0) {
      // Strip any ?subject= / ?body= tail and percent-decode, so what lands on the clipboard is the
      // bare address and nothing else.
      var address = href.slice(7).split('?')[0];
      try {
        address = decodeURIComponent(address);
      } catch (err) {
        // Malformed escape — keep the raw value rather than copying nothing.
      }

      a.setAttribute('data-copy-text', address);
      // Announces the label swap, which is the only feedback that the copy happened.
      a.setAttribute('aria-live', 'polite');

      // Stop the navigation, not the event: copy-text.js listens on document and still needs this
      // click to bubble up to it.
      a.addEventListener('click', function (event) {
        event.preventDefault();
      });
      return;
    }

    a.setAttribute('target', '_blank');
    // Modern browsers imply noopener with target=_blank; stated anyway so the intent survives.
    a.setAttribute('rel', 'noopener noreferrer');
  }

  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.querySelectorAll) root.querySelectorAll('[data-rte-links] a[href]').forEach(arm);
    // A container can itself be the added node (ss-modal adopting the accordion in), in which case
    // the selector above never matches it — its links are descendants, not descendants-of-a-match.
    if (root.matches && root.matches('[data-rte-links]')) root.querySelectorAll('a[href]').forEach(arm);
  }

  scan(document);

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) scan(added[j]);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
